exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-wrap[data-v-68ac0706]{white-space:normal!important;word-break:break-all}.bg-soft-success[data-v-68ac0706]{background-color:rgba(0,201,167,.1)!important}.bg-soft-danger[data-v-68ac0706]{background-color:rgba(237,76,120,.1)!important}.bg-soft-warning[data-v-68ac0706]{background-color:rgba(245,202,153,.1)!important}.bg-soft-secondary[data-v-68ac0706]{background-color:rgba(113,119,125,.1)!important}", ""]);

// exports
